import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_5sjsyu76az: FaireCollectionEntity = {
  token: "pbc_5sjsyu76az",
  type: "collection",
  name: "Game Day 🏈🏈",
  heroImageUrl:
    "https://cdn.faire.com/fastly/24900dfd21405f35122493a2136c9684e6bc26ab3f1130638738be4dc0dbc82f.jpeg",
  itemCount: 67,
  description:
    "It's kick off time! Perfect Tees, Hats, and Crewnecks for the Football Lover!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:38.161Z",
    importedBy: "entity-db-import-collections",
  },
};
